/** Lulu AbilitySpec seed kit (wiki-aligned numeric batch 1). */
export const LULU_ABILITY_DEFS = [
  {
    id: 'lulu_q',
    champKey: 'lulu',
    slot: 'Q',
    name: 'Glitterlance',
    targeting: 'skillshot_line',
    range: 950,
    castTime: 0.25,
    travelSpeed: 1450,
    width: 120,
    radius: 60,
    cooldown: 7,
    manaCost: 50,
    vfxId: 'lulu_q',
    status: 'wired'
  },
  {
    id: 'lulu_w',
    champKey: 'lulu',
    slot: 'W',
    name: 'Whimsy',
    targeting: 'targeted',
    range: 650,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 18,
    manaCost: 65,
    vfxId: 'lulu_w',
    cc: { type: 'silence', duration: 1.25 },
    status: 'wired'
  },
  {
    id: 'lulu_e',
    champKey: 'lulu',
    slot: 'E',
    name: 'Help, Pix!',
    targeting: 'targeted',
    range: 650,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 10,
    manaCost: 60,
    vfxId: 'lulu_e',
    status: 'wired'
  },
  {
    id: 'lulu_r',
    champKey: 'lulu',
    slot: 'R',
    name: 'Wild Growth',
    targeting: 'targeted',
    range: 900,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 400,
    duration: 7,
    cooldown: 120,
    manaCost: 100,
    vfxId: 'lulu_r',
    cc: { type: 'knockup', duration: 1 },
    status: 'wired'
  }
];
